export const AUDIO_SET_ENABLED = 'AUDIO_SET_ENABLED'          // master switch
export const AUDIO_SET_VAD_ENABLED = 'AUDIO_SET_VAD_ENABLED'  // listening/segmenting
export const AUDIO_SET_STT_ENABLED = 'AUDIO_SET_STT_ENABLED'  // posting to /audioTranscribe
export const AUDIO_START = 'AUDIO_START'
export const AUDIO_STOP = 'AUDIO_STOP'

export const AUDIO_SPEECH_SEGMENT_READY = 'AUDIO_SPEECH_SEGMENT_READY'
export const AUDIO_TRANSCRIBE_REQUEST = 'AUDIO_TRANSCRIBE_REQUEST'
export const AUDIO_TRANSCRIBE_RESULT = 'AUDIO_TRANSCRIBE_RESULT'
export const AUDIO_ERROR = 'AUDIO_ERROR'
export const AUDIO_SET_ROBOT_SPEAKING = 'AUDIO_SET_ROBOT_SPEAKING'
export const AUDIO_SET_HEARING = 'AUDIO_SET_HEARING'
export const USER_SAID = 'USER_SAID'
export const TTS_SPEAK_TOKEN = 'TTS_SPEAK_TOKEN'
